import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const Modal = ({ onClose, children, modalWidth, closeIcon, modalPosition }) => {
  // Close on "Escape" key press
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return createPortal(
    // 1. The Backdrop (Dark Overlay)
    <div
      className="overlay before:z-9999"
      onClick={onClose} // This handles the "click outside"
    >
      {/* 2. The Modal Content */}
      <div
        className={`bg-white absolute z-9999 rounded-2xl ${modalWidth ?? modalWidth} ${modalPosition ? modalPosition : "mx-auto left-0 right-0 top-1/2 translate-y-50"}`}
        onClick={(e) => e.stopPropagation()} // This prevents closing when clicking INSIDE
      >
        {children}{" "}
        {closeIcon && (
          <X
            color="#0000004d"
            className="absolute right-4 cursor-pointer top-4"
            onClick={onClose}
          />
        )}
      </div>
    </div>,
    document.body, // Renders at the end of <body> to avoid z-index issues
  );
};

export default Modal;
